import React from "react";
import {FormattedMessage} from "react-intl";


export const ProductImage = ({
  link_image,
  slim= false
}) => {
  const cls = !!link_image
    ? "bg-contain bg-center bg-no-repeat"
    : `flex items-center justify-center text-xxs ${slim ? "" : "md:text-xs"} text-gray-500 font-semibold text-center pointer-events-none p-3`;
  const widthCls = slim ? '' : 'w-20 md:w-32 lg:w-40';
  const containerStyle = {
    aspectRatio: "1",
    ...(slim ? {width: "4.5rem"} : {})
  };
  const innerStyle: React.CSSProperties = !!link_image
    ? {backgroundImage: `url(${link_image})`}
    : {};

  return (
    <div className={`${widthCls} border border-gray-300 bg-white`} style={containerStyle}>
      <div className={`w-full h-full ${cls}`} style={innerStyle}>
        {!link_image && <FormattedMessage id="image_not_available"/>}
      </div>
    </div>
  )
}